










import { Component, Vue, Watch } from 'vue-property-decorator';
import { DashboardApi } from '../api/dashboard';
import { State } from 'vuex-class';
import { AuthStateInterface } from 'modules/auth/interfaces/authState';

@Component
export default class Dashboard extends Vue {
  public loading: boolean = false;

  @State('auth') private auth!: AuthStateInterface;
  private dashboardApi: DashboardApi;

  constructor() {
    super();
    this.dashboardApi = new DashboardApi();
  }
}
